import DeviceForm from './DeviceForm'

export default DeviceForm